import ptBR from 'date-fns/locale/pt-BR'
import React from 'react'
import { MdDateRange } from 'react-icons/md'

import DateFnsUtils from '@date-io/date-fns'
import { StylesProvider } from '@material-ui/core/styles'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

import { ICalendar } from './CalendarComponent.types'
import { Container } from './styles'

const Calendar: React.FunctionComponent<ICalendar> = ({
  selectedDate,
  handleDateChange,
  autoOk,
  inputReadOnly,
}) => {
  return (
    <Container>
      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
        <StylesProvider injectFirst>
          <KeyboardDatePicker
            InputProps={{ readOnly: inputReadOnly }}
            disableToolbar
            margin="normal"
            variant="inline"
            format="dd/MM/yyyy"
            value={selectedDate}
            invalidDateMessage=""
            onChange={handleDateChange}
            autoOk={autoOk}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            keyboardIcon={<MdDateRange color="white" size={20} />}
          />
        </StylesProvider>
      </MuiPickersUtilsProvider>
    </Container>
  )
}

export default Calendar
